import { create } from 'zustand';

export type HeaderPanel = 'apps' | 'help' | 'user' | 'teams' | 'chatbot';

interface HeaderState {
  openPanel: HeaderPanel | null;
  setOpenPanel: (panel: HeaderPanel | null) => void;
  togglePanel: (panel: HeaderPanel) => void;
  closePanel: () => void;
}

export const useHeaderStore = create<HeaderState>((set, get) => ({
  openPanel: null,
  setOpenPanel: (panel) => set({ openPanel: panel }),
  togglePanel: (panel) => set({ openPanel: get().openPanel === panel ? null : panel }),
  closePanel: () => set({ openPanel: null }),
}));
